<template>
    <div v-if="chatMessage.options.text" class="chat-message__container" id="make-model-chat-message">
        <div v-if="chatMessage.type === MakeModelChatType.BotMessage">
            <div class="chat-message__message chat-message__bot-message">
                <span v-html="displayMessage"></span>
                <div class="chat-message__tail chat-message__tail--bot"></div>
            </div>
        </div>
        <div v-if="chatMessage.type === MakeModelChatType.UserMessage">
            <div class="chat-message__message chat-message__user-message">
                {{ displayMessage }}
                <div class="chat-message__tail chat-message__tail--user"></div>
            </div>
        </div>
        <div v-if="chatMessage.type === MakeModelChatType.InfoMessage">
            <div class="chat-message__message info-message">
                <span v-html="displayMessage"></span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import MakeModelChatType from '@/enums/MakeModelChatType';
import ChatMessage from '@/models/vehicle/makeModelBot/chatMessage';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    components: {

    }
})

export default class ChatMessageComponent extends Vue {
    @Prop({ default: '' })
    public chatMessage!: ChatMessage;

    public MakeModelChatType = MakeModelChatType;

    public displayMessage: string = '';

    async mounted() {
        this.typeMessage();
        this.$watch(() => this.chatMessage.options.text, () => {
            this.typeMessage();
        });
    }

    private typeMessage() {
        if (!this.chatMessage.options.text) {
            return;
        }
        // simulate typing effect
        // IMPORTANT: when remaking, we need to figure out how to make the chat messages sequential. It can be solved by emitting 
        // to the top level when a message is done typing, and having a queue set up to do the messages one at a time - Alex
        const it = this.chatMessage.options.text.split(' ')[Symbol.iterator]();
        const int = setInterval(() => {
            const next = it.next();
            if (!next.done) {
                this.displayMessage += `${next.value} `;
            } else {
                clearInterval(int);
                this.chatMessage.isFinished = true;
            }
        }, this.randomIntFromInterval(10, 40));
    }

    randomIntFromInterval(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
}
</script>
